import React from 'react';

import GoogleLogin from './GoogleLogin';
import styles from './Login.module.css';

const Login = ({ onLogin = null }) => {
  return (
    <div className={styles.wrapper}>
      <GoogleLogin onLogin={onLogin} />
    </div>
  );
};

export default Login;
